import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectVulnsSelected } from 'store/ManageGeneral/selectors';
import { selectVulnRow } from 'store/ManageGeneral/actions';
import SelectionCell from 'shared/ui/Table/cells/SelectionCell';
import Skeleton from 'Common/Components/Skeleton';
import { sameVulnId } from 'Common/Functions/vulnerabilityId';

const CheckColumnVulnsGeneral = ({ vuln, showSkeleton }) => {
  const vulnsSelected = useSelector(selectVulnsSelected);
  const dispatch = useDispatch();
  const isSelected = vulnsSelected.find((vulnSelected) => sameVulnId(vulnSelected, vuln));
  const handleClick = (e) => dispatch(selectVulnRow(e, vuln));

  if (showSkeleton) return <Skeleton />;
  return (
    <SelectionCell checked={ !!isSelected } onChange={ handleClick } />
  );
};

export default CheckColumnVulnsGeneral;
